// Predefined feature flag names
export const FEATURE_FLAG_NAMES = [
  'HIDE_ELEMENTS',
  'DATA_COLLECTION',
  'USE_EXA',
  'SEGMENT_EVENT',
  'QUANTUM',
  'DC_USER',
  'WELCOME_VISIBLE',
  'PMI_MONITORING',
  'QUANTUM_CONTENT',
  'THIRD_PARTY_COLLECTION',
  // Shows raw backend error text in the app instead of the friendly message.
  // For debugging a live environment — grant it to the engineer's own user,
  // not to a company, or customers see pydantic validation dumps.
  'RAW_ERROR_DETAILS',
  // Booth demo — the operator board for a stand full of wearable sensors,
  // driven by a Raspberry Pi. Checked with scope BOTH, so granting it to
  // either the user or the company switches the section on.
  'BOOTH_DEMO',
  'RAW_DEBUG_DETAILS',
  // Shows the planned-but-unbuilt product surfaces — Insights, Journeys,
  // Recommendations, Alerts, Reports, Data health — in the customer's left
  // nav as ordinary, working-looking links. Each one navigates to a real
  // route that says plainly what the feature will do and that it is not
  // built yet.
  //
  // Grant it for demos and design review. Do NOT grant it to a customer who
  // is deciding whether to buy on the strength of what they can see: every
  // destination is a placeholder, and the links are deliberately styled to
  // look finished.
  'COMING_SOON',
  // Hides the estimated cost on the Quantum run launch screen. A kill switch,
  // not an opt-in: the estimate shows by default and this takes it away, for
  // customers on a plan where per-run cost is not their concern, or where the
  // figure would only invite a conversation about a number that is an
  // approximation anyway. The estimated TIME is unaffected — that is
  // operational, not commercial.
  'PRICE_HIDE'
];

export default FEATURE_FLAG_NAMES;
